import React from 'react';
import styled from 'styled-components';

import { Attachment } from '@features/siteStatusV2/types';
import AttachmentItem from './AttachmentItem';

interface AttachmentItemProps {
  attachments: Attachment[];
}

const AttachmentItems: React.FC<AttachmentItemProps> = ({ attachments }) => {
  return (
    <AttachmentItemsContainer>
      {attachments.map((attachment) => (
        <AttachmentItem attachment={attachment} key={attachment.id} />
      ))}
    </AttachmentItemsContainer>
  );
};

const AttachmentItemsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
`;

export default AttachmentItems;
